<template>
  <v-app>
    <v-navigation-drawer 
      absolute 
      temporary
      right
      v-model="sideNav"
    >
      <v-list>
        <v-list-tile v-if="userIsAuthenticated">
          <v-list-tile-action>
            <v-icon>face</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            {{ user.contact.emailAddress }}
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile @click="onLogout">
          <v-list-tile-action>
            <v-icon>exit_to_app</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            Logout
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>
    <v-toolbar flat dark style="padding: 0 0 0 20px">
      <v-toolbar-title>
        <div class="brand-logo">
          <!-- <img src="./brands/ice/logo.png"> -->
          <!-- <img :src="getBrandUrl(brand, 'logo.png')"> -->
          <router-link :to="{ path: '/' }">
            <img v-if="brand.logo.svgPath" :src="getLogo(brand, 'logo.svg')" class="brand-svg">
            <img v-else :src="getLogo(brand, 'logo.png')">
          </router-link>
        </div>
      </v-toolbar-title>
      <v-spacer></v-spacer> 
      <v-toolbar-items class="hidden-sm-and-down">
        <v-menu offset-y v-if="userIsAuthenticated">
          <v-btn flat dark slot="activator">{{ user.contact.emailAddress }}</v-btn>
          <v-list>
            <v-list-tile @click="onLogout">
              <v-list-tile-title><v-icon>exit_to_app</v-icon> Logout</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
      </v-toolbar-items>
      <v-toolbar-side-icon 
        v-if="userIsAuthenticated"
        @click.stop="sideNav = !sideNav" 
        class="hidden-md-and-up"
      >
      </v-toolbar-side-icon>

    </v-toolbar>
    <main>
      <v-container fluid>
        <v-layout row wrap>
          <v-flex xs12 sm10 offset-sm1 class="mt-4 mb-4">
            <v-slide-y-transition mode="out-in">
              <router-view></router-view>
            </v-slide-y-transition>
          </v-flex>          
        </v-layout>
        <v-layout row wrap class="mt-5">
          <v-flex>
            <v-footer class="pa-3" absolute dark>
              <v-spacer></v-spacer>
              <div>© {{ new Date().getFullYear() }} {{ brand.displayName }}</div>
            </v-footer>
          </v-flex>
        </v-layout>
      </v-container>
    </main>
  </v-app>
</template>

<script>
  export default {
    data () {
      return {
        sideNav: false
      }
    },
    computed: {
      userIsAuthenticated () {
        return this.$store.getters.user !== null && this.$store.getters.user !== undefined
      },
      user () {
        return this.$store.getters.user
      }
    },
    methods: {
      onLogout () {
        console.log('Logging out...')
        this.$store.dispatch('logout')
        this.$router.push('/')
      }
    }
  }
</script>

<style lang="scss">
  img {
    max-width: 100%;
  }

  .uppercase {
    text-transform: uppercase;
  }

  .brand-logo {
    max-width: 120px;
    margin: 0 auto;
    text-align: center;

    > img.brand-svg {
      height: 40px;
      margin-top: -20px;
    }
  }

  /**
   * OVERRIDES
   */
  .application.theme--light {
    background: #fafafa;
  }

  .theme--dark .toolbar, 
  .application .theme--dark.toolbar {
    background: #105079;
    color: #fff;
  }

  .theme--dark .footer, 
  .application .theme--dark.footer {
    background: #2d5168;
    color: #fff;
  }

  .theme--light .input-group:not(.input-group--error) .input-group__details:before, 
  .application .theme--light.input-group:not(.input-group--error) .input-group__details:before {
    background: none;
    border-top: 1px dotted #d0d0d0;
  }

  .theme--light .input-group:not(.input-group--error) .input-group__details:before, 
  .application .theme--light.input-group:not(.input-group--error) .input-group__details:before {
    background: none;
    border-top: 1px dotted #d0d0d0;
  }

  .input-group.input-group--error .input-group__details:before {
    background: none;
    border-top: 1px dotted rgb(255, 65, 65);   
  }

  .theme--light.input-group:not(.input-group--error):not(.input-group--focused):not(.input-group--disabled):not(.input-group--disabled):not(.input-group--overflow):not(.input-group--segmented):not(.input-group--editable):hover .input-group__details:before, 
  .theme--light .input-group:not(.input-group--error):not(.input-group--focused):not(.input-group--disabled):not(.input-group--disabled):not(.input-group--overflow):not(.input-group--segmented):not(.input-group--editable):hover .input-group__details:before {
    background-color: #d0d0d0;
  }

  /* Equal Height Cards */
  .card.eq-height {
    display: flex;
    flex: 1 1 0%;
    flex-direction: column;
    overflow: hidden;

    > .card__title {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
      flex: 1 1 auto;
    }
  }

  /* Alerts */
  .application .alert a {
    color: #fff;
  }

  /* block buttons */
  // @media (max-width: 959px) {
  //   .col-xs-12.btn-block > .btn {
  //     display: 
  //   }
  // }
</style>



// WEBPACK FOOTER //
// src/App.vue